export class AdverseModel{
    "patientId":Number;
    "userId":Number
}